import React from 'react';
import { useEditEventContext } from '../../contexts/EditEventContext';
import { TAppElkBackgroundAnimation } from 'TProtocol/prototypes/events/messages';
import AnimationOption from './AnimationOption';
import styled from 'styled-components';
import { DeviceQueries } from 'Common/src/components/styled';

const SELECTABLE_ANIMATIONS = [
  TAppElkBackgroundAnimation.LIGHT_SOURCE,
  TAppElkBackgroundAnimation.FIREWORKS,
  TAppElkBackgroundAnimation.CHAMPAGNE_BUBBLES,
  TAppElkBackgroundAnimation.BLURRY_BUBBLES,
  TAppElkBackgroundAnimation.BLURRED_LINES
];

const EventAnimationPicker = () => {
  const eventContext = useEditEventContext();

  let eventAnimation = eventContext.event?.animation;

  if (eventAnimation === undefined || SELECTABLE_ANIMATIONS.indexOf(eventAnimation) === -1) {
    eventAnimation = TAppElkBackgroundAnimation.LIGHT_SOURCE;
  }

  return <ScrollableDiv>
    {
      SELECTABLE_ANIMATIONS.map(
        (animation) => <AnimationOption
          key={animation}
          animation={animation}
          selected={animation === eventAnimation}
          onSelect={eventContext.setAnimation}/>
      )
    }
  </ScrollableDiv>;
};

export default EventAnimationPicker;

const ScrollableDiv = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;

  @media (${DeviceQueries.mobile}) {
    margin-bottom: 20px;
  }

  @media not (${DeviceQueries.mobile}) {
    justify-content: space-evenly;
  }
`;
